import {
  BookingResponse,
  bookingStatusResponse,
} from 'types/BookingConfirmation';
import { BookingDetailResponse } from 'types/BookingDetails';
import {
  CreateBookingApiResponse,
  createBookingTypes,
} from 'types/CreateBooking';
import {
  ProductResponseType,
  ReservationPayload,
} from 'types/ProductReservationType';
import { VehicleResponse } from 'types/products';
import { SearchPayload, SearchResponse } from 'types/searchPayload';
import bookingApi from './bookingApi';

export const validateBranchWithLive = async (
  payload: SearchPayload
): Promise<SearchResponse> => {
  const { data } = await bookingApi.post<SearchResponse>(
    `/booking/search`,
    payload
  );
  return data;
};

export const createBooking = async (
  payload: createBookingTypes
): Promise<CreateBookingApiResponse> => {
  const response = await bookingApi.post<CreateBookingApiResponse>(
    `/booking/create`,
    payload
  );
  return response.data;
};

export const getVehicles = async (id: string): Promise<VehicleResponse> => {
  const response = await bookingApi.get<VehicleResponse>(
    `/booking/listing?id=${id}`
  );
  return response.data;
};

export const getBooking = async (
  bookingId: string
): Promise<BookingResponse> => {
  const response = await bookingApi.get<BookingResponse>(
    `/booking/${bookingId}`
  );
  return response.data;
};

export const getBookingDetail = async (
  id: string,
  vId: string
): Promise<BookingDetailResponse> => {
  const response = await bookingApi.get<BookingDetailResponse>(
    `/booking/detail/${id}/${vId}`
  );
  return response.data;
};

export const getBookingCheckout = async (
  id: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingApi.get<BookingDetailResponse>(
    `/booking/checkout/?id=${id}`
  );
  return data;
};

export const getBookingStatus = async (
  bookingId: string
): Promise<bookingStatusResponse> => {
  const response = await bookingApi.get<bookingStatusResponse>(
    `/booking/status/${bookingId}`
  );
  return response.data;
};
